export const SET_LOADING_SPINNER = 'SET_LOADING_SPINNER';
export const SET_ERROR_MESSAGES = 'SET_ERROR_MESSAGES';
export const SET_SUCCESS_MESSAGES = 'SET_SUCCESS_MESSAGES';
export const GET_ALL_REBATE_PROGRAMS_CGPS = 'GET_ALL_REBATE_PROGRAMS_CGPS';
export const SET_CGP_SEARCH_VALUES = 'SET_CGP_SEARCH_VALUES';
export const GET_DETAIL_TABLE_DATA = 'GET_DETAIL_TABLE_DATA';
export const SET_DEFAULT_QTR = 'SET_DEFAULT_QTR';
export const SET_STORED_GROUPING_COLUMNS = 'SET_STORED_GROUPING_COLUMNS';
export const SET_DETAIL_ERROR_MESSAGES = 'SET_DETAIL_ERROR_MESSAGES';
export const SET_DETAIL_SUCCESS_MESSAGES = 'SET_DETAIL_SUCCESS_MESSAGES';
export const SET_SHOW_ALL_HISTORY = 'SET_SHOW_ALL_HISTORY';
export const SET_TABLE_ADD = 'SET_TABLE_ADD';
export const SET_TABLE_EDIT = 'SET_TABLE_EDIT';
export const SET_TABLE_EDITED_DATA = 'SET_TABLE_EDITED_DATA';
export const SET_VALIDATE_TRIGGER = 'SET_VALIDATE_TRIGGER';
export const RESET_CGP_STORE = 'RESET_CGP_STORE';
export const RESET_REQUEST_CGP_STORE = 'RESET_REQUEST_CGP_STORE';
export const RESET_CGP_DETAIL_STORE = 'RESET_CGP_DETAIL_STORE';
export const DELETE_ROW_INDEX = 'DELETE_ROW_INDEX';